angular.module 'zc.master.campaigns'

.controller 'MasterCampaignsCtrl', (
    $filter,
    $q,
    $sce,
    $scope,
    $timeout,
    $translate,
    Page,
    Campaign,
    DataScriptCampaignResults,
    AccessStats,
    MasterCampaign,
    MasterCampaignStats,
    SearchFilter,
    templates,
    currentUser,
    lib) ->

  Page.setBodyClass ''
  $translate('masterCampaigns.list.campaignList').then (translation) ->
    Page.setTitle translation

  # campaigns
  $scope.campaigns = []
  $scope.filteredCampaigns = []
  $scope.pagedCampaigns = []

  # pagination
  $scope.pagination =
    itemsPerPage: 30
    currentPage: 1

  # filters
  $scope.previousFilters = {}
  $scope.filters = SearchFilter.resolveFromLocation()
  SearchFilter.setComponentDefaults('masterCampaignList', {
    visible_group:
      default: 'stats'
    campaign_scope:
      default: 'active'
    product_line:
      default: 'all'
    sort_prop:
      default: 'start_at'
    sort_direction:
      default: 'asc'
    assigned:
      default: false
    is_widget:
      default: false
  })

  $scope.$on '$destroy', () ->
    SearchFilter.removeComponentDefaults('masterCampaignList')

  $scope.fromNow = (end_at) ->
    moment(end_at).fromNow(true)


  $scope.getCampaigns = ->
    SearchFilter.set $scope.filters
    MasterCampaign.all
      start_at: moment($scope.filters.start_at).valueOf()
      end_at: moment($scope.filters.end_at).add(1, 'day').valueOf()
    .then (campaigns) ->
      $scope.campaigns = campaigns
      $scope.filterCampaigns()
      $scope.previousFilters = _.merge({}, $scope.filters)

  $scope.getCampaigns()

  $scope.pageChanged = ->
    begin = $scope.pagination.itemsPerPage * ($scope.pagination.currentPage - 1)
    $scope.pagedCampaigns = _.filter $scope.filteredCampaigns, (campaign, i) ->
      begin <= i < begin + $scope.pagination.itemsPerPage

  $scope.getTemplate = (template) ->
    res = _.filter(templates, (t) -> t.name == template)
    res[0].template

  $scope.setSortProp = (key) ->
    if $scope.filters.sort_prop == key
      if $scope.filters.sort_direction = 'desc'
        $scope.filters.sort_direction = 'asc'
      else
        $scope.filters.sort_direction = 'desc'
    else
      $scope.filters.sort_prop = key
      $scope.filters.sort_direction = 'desc'
    $scope.filterCampaigns()

  $scope.setVisibleGroup = (visibleGroup) ->
    $scope.filters.visible_group = visibleGroup
    calculateSegments() if $scope.filters.visible_group is 'segment'
    SearchFilter.updateComponentDefaults('masterCampaignList')

  $scope.saveCampaign = (campaign) ->
    Campaign.update({
      projectId: campaign.project_id
      campaignId: campaign.id
    }, campaign).then (res) ->
      _.merge campaign, res.campaign

  $scope.filterClicked = ->
    if $scope.filters.start_at != $scope.previousFilters.start_at || $scope.filters.end_at != $scope.previousFilters.end_at
      $scope.getCampaigns()
    else
      $scope.filterCampaigns()

  $scope.filterCampaigns = ->
    sortDirectionReverse = ($scope.filters.sort_direction == 'desc')

    # do the filtering
    $scope.filteredCampaigns = filterByProductLine $scope.campaigns, $scope.filters.product_line
    $scope.filteredCampaigns = filterByCurrentStatus $scope.filteredCampaigns, $scope.filters.campaign_scope
    $scope.filteredCampaigns = filterByUser $scope.filteredCampaigns if $scope.filters.assigned
    $scope.filteredCampaigns = filterByIsWidget $scope.filteredCampaigns if $scope.filters.is_widget
    $scope.filteredCampaigns = $filter('campaignText')($scope.filteredCampaigns, $scope.filters.search_term)

    promises = []

    # we need to update stats before sorting...
    if $scope.visibleGroup is 'analytics'
      promises.push calculateSegments()
    else if $scope.filters.visible_group is 'stats'
      # note: includes calculateStats includes calculateSegments also
      promises.push calculateStats()

    $q.all(promises)
    .then () ->

      # only after resolving necessary stats etc, do the sorting
      $scope.filteredCampaigns = $filter('orderBy')($scope.filteredCampaigns, $scope.filters.sort_prop, sortDirectionReverse)
      $scope.filteredCampaigns = $filter('emptyToEnd')($scope.filteredCampaigns, $scope.filters.sort_prop, sortDirectionReverse)

      $scope.pagination.currentPage = 1
      $scope.pageChanged()
      SearchFilter.set $scope.filters
      SearchFilter.updateComponentDefaults('masterCampaignList')

  $scope.resetSearchTerm = () ->
    $scope.filters.search_term = ""
    $scope.filterCampaigns()

  filterByCurrentStatus = (campaigns, campaignScope) ->
    _.filter campaigns, (campaign) ->
      switch campaignScope
        when 'active' then campaign.current_status in ['active', 'pending']
        when 'preview' then campaign.current_status is 'preview'
        when 'incomplete' then campaign.current_status is 'incomplete'
        else true

  filterByProductLine = (campaigns, productLine) ->
    _.filter campaigns, (campaign) ->
      return true if productLine == 'all'
      campaign.project_product_line == productLine

  filterByUser = (campaigns) ->
    if assigned?
      _.filter campaigns, (campaign) ->
        for user in campaign.project_users
          return true if user.id == currentUser.id

  filterByIsWidget = (campaigns) ->
    _.filter campaigns, (campaign) ->
      return true if campaign.is_widget

  calculateStats = ->
    campaignIds = (campaign.id for campaign in $scope.filteredCampaigns)
    $q.all [
      calculateAll(campaignIds)
      calculateLastHour(campaignIds)
      fetchStolenCVRates(campaignIds)
    ]
    .then ([campaign_stats, last_campaign_stats, stolen_conversion_rates]) ->
      statsById = MasterCampaignStats.statsById campaign_stats
      lastStatsById = MasterCampaignStats.statsById last_campaign_stats
      for campaign in $scope.filteredCampaigns
        campaign.stats = statsById[campaign.id]
        campaign.stolen_conversion_rate = stolen_conversion_rates[campaign.id]
        campaign.last_stats = lastStatsById[campaign.id]
        if campaign.stats
          MasterCampaignStats.calculate campaign.stats
          MasterCampaignStats.chisq campaign.stats, campaign.control_percent
      calculateTotals()
    .then (totals) ->
      calculateSegments()
    .then (totals) ->
      for campaign, i in $scope.filteredCampaigns
        if !campaign.total_stats?.session_count
          campaign.segment_cover_percentage = 0
          campaign.experimental_delivery_percentage = 0
        else
          campaign.segment_cover_percentage = (campaign.access_stats.session_count || 0) / campaign.total_stats.session_count * 100
          campaign.experimental_delivery_percentage = (campaign.stats?.experimental?.delivery_count || 0) / campaign.total_stats.session_count * 100

        if !campaign.total_stats?.conversion_price
          campaign.experimental_conversion_price_percentage = 0
        else
          campaign.experimental_conversion_price_percentage = (campaign.stats?.experimental?.conversion_price || 0) / campaign.total_stats.conversion_price * 100

  calculateAll = (campaignIds) ->
    masterCampaignStats = new MasterCampaignStats 'daily'
    masterCampaignStats.aggregate
      campaign_ids: campaignIds
      start_at: $scope.filters.start_at
      end_at: moment($scope.filters.end_at).add(1, 'day').valueOf()

  calculateLastHour = (campaignIds) ->
    masterCampaignStats = new MasterCampaignStats 'hourly'
    masterCampaignStats.find
      campaign_ids: campaignIds
      start_at: moment().subtract(3, "hours").startOf('hour').valueOf()
      end_at: moment().subtract(3, "hours").endOf('hour').valueOf()

  fetchStolenCVRates = (campaignIds) ->
    dataScriptCampaignResults = new DataScriptCampaignResults
    dataScriptCampaignResults.find
      match:
        name: "stolen_conversion_rate"
        campaign_id:
          "$in": campaignIds
        start_at:
          "$gte": moment().startOf("day").subtract(14, "days").toDate()
      sort:
        start_at: -1
    .then (params) ->
      _.chain params
      .keyBy 'campaign_id'
      .mapValues (value) ->
        if Array.isArray value
          _.maxBy value, (x) -> x.start_at
        else
          value
      .value()

  # used to calculating delivery percentage
  calculateTotals = ->
    promises = for campaign in $scope.filteredCampaigns
      AccessStats.aggregateDefault
        dimension: 'hourly'
        apikey: campaign.apikey
      ,
        device: null # total for site
        is_control: null # total for site
        campaign_segment_id: null
        start_at:
          $gte: _.max([moment(campaign.start_at).toDate(), moment($scope.filters.start_at).toDate()])
          $lt: _.min([moment(campaign.end_at).toDate(), moment($scope.filters.end_at).add(1, 'days').toDate()])
    $q.all(promises).then (access_stats) ->
      for campaign, i in $scope.filteredCampaigns
        campaign.total_stats = access_stats[i]?[0]

  calculateSegments = ->
    promises = for campaign in $scope.filteredCampaigns
      device = AccessStats.handleCampaignDevice campaign.campaign_device
      campaign_segment_id = campaign.segment?.id || null
      AccessStats.aggregateDefault
        dimension: 'hourly'
        apikey: campaign.apikey
      ,
        device: device
        is_control: null
        campaign_segment_id: campaign_segment_id
        start_at:
          $gte: _.max([moment(campaign.start_at).toDate(), moment($scope.filters.start_at).toDate()])
          $lt: _.min([moment(campaign.end_at).toDate(), moment($scope.filters.end_at).add(1, 'days').toDate()])
    $q.all(promises)
    .then (access_stats) ->
      for campaign, i in $scope.filteredCampaigns
        campaign.access_stats = access_stats[i]?[0]



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.campaigns/list.controller.js.coffee